import { Box, Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { ReceivedBseBidDto } from "../../../../../autogen/bff-api";
import { SharedDocumentsTable } from "../../../../../common/documents/SharedDocumentsTable/SharedDocumentsTable";
import { TipTap } from "../../../../../common/input/TipTap/TipTap";

export const BidContent = ({
  bid,
  totalPrice,
  savings,
  originalTotal,
  latestTotal,
  hasProducts,
}: {
  bid: ReceivedBseBidDto;
  totalPrice?: number;
  savings?: number;
  originalTotal?: number;
  latestTotal?: number;
  hasProducts: boolean;
}) => {
  return (
    <Flex direction="column" gap={4}>
      {hasProducts && (
        <Flex gap={4} wrap="wrap">
          {totalPrice != null && (
            <Box border="1px solid" borderColor="smBorder" rounded="md" p="4" bg="smBackground" flex="1 1 260px">
              <Text as="h3" fontWeight="semibold" mb="1">
                {t("Total price")}
              </Text>
              <Text fontSize="3xl" fontWeight="semibold">
                {totalPrice.toLocaleString()}
              </Text>
            </Box>
          )}
          {(savings || savings === 0) && (
            <Box border="1px solid" borderColor="smBorder" rounded="md" p="4" bg="smBackground" flex="1 1 260px">
              <Text as="h3" fontWeight="semibold" mb="1">
                {t("Savings since original")}
              </Text>

              <Text
                fontSize="2xl"
                fontWeight="semibold"
                color={savings > 0 ? "red.500" : savings < 0 ? "green.500" : "smMuted"}
              >
                {(savings ? -savings : 0)?.toLocaleString()}
              </Text>
              <Text fontSize="sm" color="smMuted" mt="1">
                {originalTotal != null ? `${t("Original bid")}: ${originalTotal.toLocaleString()}` : ""}{" "}
                {latestTotal != null ? `• ${t("Latest")}: ${latestTotal.toLocaleString()}` : ""}
              </Text>
            </Box>
          )}
        </Flex>
      )}
      <Box border="0" borderColor="transparent" rounded="md" p="0" bg="transparent">
        <Text as="h3" fontWeight="semibold" mb="2">
          {t("Comment from seller")}
        </Text>
        <TipTap content={bid.comment} editable={false} maxHeight="60" documents={bid.commentDocuments} />
      </Box>
      <Box border="0" borderColor="transparent" rounded="md" p="0" bg="transparent">
        <Text as="h3" fontWeight="semibold" mb="2">
          {t("Documents")}
        </Text>
        <SharedDocumentsTable documents={bid.documents} />
      </Box>
    </Flex>
  );
};
